import {
  ADD_PROPERTY,
  SET_PROPERTIES,
  UPDATE_PROPERTY,
  SET_ACTIVE_PROPERTY,
  SET_PUBLIC_PROPERTY, // new
  // SET_PRIVATE_SHARE,
  SET_FETCHING_PROPERTIES,
  SET_FETCHING_PROPERTIES_ERROR,
  SET_DOCUMENTS_TO_SIGNED,
  SET_FETCHING_DOCUMENTS_TO_SIGNED,
  SET_DIALOG_TO_SIGN_DOC_SEEN,
  SET_AD_CAROUSEL_CLOSED,
  SET_PROPERTY_COMPANY_STATS,
  SET_PROPERTY_VALUE_INCREASES,
  SET_PROPERTY_VALUE_ESTIMATES,
  SET_PROPERTY_DOCUMENT_STATISTICS,
} from '../reducers/properties';

import { storeActivePropertyUid } from '../../utils/properties';

export const acSetProperties = (properties) => ({
  type: SET_PROPERTIES,
  payload: properties,
});

export const acAddProperty = ({ isOwned, property }) => ({
  type: ADD_PROPERTY,
  payload: { property, isOwned },
});

export const acSetActiveProperty = (property) => {
  storeActivePropertyUid(property);

  return {
    type: SET_ACTIVE_PROPERTY,
    payload: property,
  };
};

export const propertyUpdateAction = (property) => {
  return {
    type: UPDATE_PROPERTY,
    payload: property,
  };
};

export const acSetFetchingProperties = (fetching) => ({
  type: SET_FETCHING_PROPERTIES,
  payload: fetching,
});

export const acSetPublicProperty = (property) => ({
  // new
  type: SET_PUBLIC_PROPERTY,
  payload: property,
});

// export const acSetPrivateShare = (state) => ({ // new
//   type: SET_PRIVATE_SHARE,
//   payload: state,
// });

export const acSetFetchingPropertiesError = (error) => ({
  type: SET_FETCHING_PROPERTIES_ERROR,
  payload: error,
});

export const acSetDocumentsToSigned = (data) => ({
  type: SET_DOCUMENTS_TO_SIGNED,
  payload: data,
});

export const acSetFetchingDocumentsToSigned = (data) => ({
  type: SET_FETCHING_DOCUMENTS_TO_SIGNED,
  payload: data,
});

export const acSetDialogToSignDocSeen = (data) => ({
  type: SET_DIALOG_TO_SIGN_DOC_SEEN,
  payload: data,
});

export const acSetAdCarouselClosed = (data) => ({
  type: SET_AD_CAROUSEL_CLOSED,
  payload: data,
});

export const acSetPropertyValueIncreases = (data) => ({
  type: SET_PROPERTY_VALUE_INCREASES,
  payload: data,
});

export const acSetPropertyValueEstimates = (data) => ({
  type: SET_PROPERTY_VALUE_ESTIMATES,
  payload: data,
});

export const acSetPropertyDocumentStatistics = (data) => ({
  type: SET_PROPERTY_DOCUMENT_STATISTICS,
  payload: data,
});

export const acSetPropertyCompanyStats = (data) => ({
  type: SET_PROPERTY_COMPANY_STATS,
  payload: data,
});
